import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {
  DRAWER_PLACEMENTS,
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerPopup,
  DrawerPortal,
  DrawerTitle,
  DrawerViewport
} from '@adv-mt/ui/drawer'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-baseDrawer`

const BaseDrawer = ({children, footer, hasFooter = true, onClose, title}) => {
  const {i18n} = useSuiContext()

  return (
    <DrawerPortal>
      <DrawerBackdrop />
      <DrawerViewport>
        <DrawerPopup placement={DRAWER_PLACEMENTS.RIGHT}>
          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle>{title}</DrawerTitle>
              <DrawerCloseButton aria-label={i18n.t('COMMON_CLOSE')} />
            </DrawerHeader>
            {/* Base UI's touch swipe-to-dismiss claims a vertical drag that starts with sideways jitter and blocks the
                body's native scroll on iOS. This attribute makes it ignore touches inside the scroll area. */}
            <DrawerBody className={`${BASE_CLASS}-body`} data-base-ui-swipe-ignore="">
              {children}
            </DrawerBody>
            {hasFooter && (
              <DrawerFooter direction="stacked">
                {footer ?? (
                  <Button
                    onClick={onClose}
                    intent={BUTTON_INTENTS.PRIMARY}
                    shape={BUTTON_SHAPES.CIRCLE}
                    variant={BUTTON_VARIANTS.SOLID}
                  >
                    {i18n.t('COMMON.UNDERSTOOD')}
                  </Button>
                )}
              </DrawerFooter>
            )}
          </DrawerContent>
        </DrawerPopup>
      </DrawerViewport>
    </DrawerPortal>
  )
}

BaseDrawer.displayName = 'BaseDrawer'

BaseDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  hasFooter: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default BaseDrawer
